"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireDefault(require("react-select"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var safeTrim = function safeTrim() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return item && item.trim ? item.trim() : '';
};
var defaultOption = function defaultOption(item) {
  return {
    value: item,
    label: item
  };
};
var splitValuesBySemicolon = function splitValuesBySemicolon() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var transformer = arguments.length > 1 ? arguments[1] : undefined;
  return R.map(function (item) {
    return defaultOption(transformer(safeTrim(item)));
  }, string.trim().split(';'));
};
var MultiInput = /*#__PURE__*/function (_React$Component) {
  function MultiInput(props) {
    var _this;
    _classCallCheck(this, MultiInput);
    _this = _callSuper(this, MultiInput, [props]);
    _defineProperty(_this, "onChange", function (selections) {
      var agg = [];
      selections.map(function (item) {
        var split = R.filter(function (option) {
          return option.value;
        }, splitValuesBySemicolon(item.value, _this.props.transformer));
        agg = agg.concat(split);
        return agg;
      });
      agg = R.map(defaultOption, R.uniq(R.pluck('value', agg)) || []);
      _this.setState({
        options: agg
      });
      return agg;
    });
    _this.state = {
      options: R.map(defaultOption, props.value || [])
    };
    return _this;
  }
  _inherits(MultiInput, _React$Component);
  return _createClass(MultiInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var separator = this.props.separator;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"].Creatable, _extends({
        multi: true,
        clearable: true,
        searchable: true,
        noResultsText: null,
        onInputChange: function onInputChange(value) {
          if (value.indexOf(separator) !== -1) {
            R.compose(_this2.props.onChange, _this2.onChange)([].concat(_toConsumableArray(_this2.state.options), [{
              value: value,
              label: value
            }]));
            return '';
          }
          return value;
        },
        onInputKeyDown: function onInputKeyDown(event) {
          switch (event.keyCode) {
            case 13: // ENTER
            case 9:
              // tab
              event.preventDefault();
              break;
            default:
          }
        },
        arrowRenderer: function arrowRenderer() {
          return null;
        },
        menuRenderer: function menuRenderer() {
          return null;
        },
        shouldKeyDownEventCreateNewOption: function shouldKeyDownEventCreateNewOption(_ref) {
          var keyCode = _ref.keyCode;
          return keyCode === 186;
        }
      }, this.props, {
        options: this.state.options,
        onChange: R.compose(this.props.onChange, this.onChange)
      })));
    }
  }]);
}(_react["default"].Component);
MultiInput.propTypes = {
  separator: _propTypes["default"].string,
  transformer: _propTypes["default"].func,
  onChange: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({})), _propTypes["default"].arrayOf(_propTypes["default"].string)])
};
MultiInput.defaultProps = {
  separator: ';',
  transformer: R.identity,
  value: []
};
var _default = exports["default"] = MultiInput;